import { VIDEO_VOTING_SESSION_STATES } from 'open-modules/zdf/videovoting/videoVotingSession';
import { CLICK } from 'system/demo';
import { t } from 'util/stdtypes';

import { videoVotingDemoTemplates } from './videovoting.data';
import { DemoVideoVotingContainer } from './videovotingdemo.util';

const templateConnected = videoVotingDemoTemplates.templateConnected;
const templateIndividual = videoVotingDemoTemplates.templateIndividual;

const linkedThread = {
    structureKey: 'question',
    instanceKey: 'godzilla',
};

const modulePublicIndividual = {
    videovoting: { all: { i: { template: templateIndividual, linkedThread } } },
};

const modulePublicConnected = {
    videovoting: { all: { c: { template: templateConnected, linkedThread } } },
};

const showQuestionStateIndividual = {
    personaKey: 'a',
    template: templateIndividual,
    state: VIDEO_VOTING_SESSION_STATES.waitForQuestion,
    currentQuestionKey: templateIndividual.questions[1].key,
    anonymous: false,
    questions: {
        [templateIndividual.questions[0].key]: { answered: true },
    },
};

const finalQuestionStateIndividual = {
    personaKey: 'a',
    template: templateIndividual,
    state: VIDEO_VOTING_SESSION_STATES.waitForQuestion,
    currentQuestionKey: null,
    anonymous: false,
    questions: {
        [templateIndividual.questions[1].key]: { answered: true },
        [templateIndividual.questions[2].key]: { answered: true },
    },
};

const finalQuestionStateConnected = {
    personaKey: 'a',
    template: templateConnected,
    state: VIDEO_VOTING_SESSION_STATES.waitForQuestion,
    currentQuestionKey: null,
    anonymous: false,
    questions: {
        [templateConnected.questions[0].subQuestions[0].key]: { answered: true },
        [templateConnected.questions[0].subQuestions[1].key]: { answered: true },
        [templateConnected.questions[0].subQuestions[2].key]: { answered: true },
    },
};

const showQuestionStateConnected = {
    personaKey: 'a',
    template: templateConnected,
    state: VIDEO_VOTING_SESSION_STATES.waitForQuestion,
    currentQuestionKey: templateConnected.questions[0].subQuestions[0].key,
    anonymous: false,
    questions: {},
};

const videoStateLoaded = {
    isPlaying: false,
    currentTime: 600,
    duration: 900,
    ended: false,
    ready: true,
};

const videoStateSecondQuestionIndividual = {
    ...videoStateLoaded,
    currentTime: 600,
};

const videoStateFirstQuestionConnected = {
    ...videoStateLoaded,
    currentTime: 490,
};

const videoStateFinalQuestion = {
    ...videoStateLoaded,
    currentTime: 830,
};

const collectionQuestion = [{ key: 'godzilla', name: 'Is godzilla good?', from: 'a' }];
const collectionDerived_questionPreview = [{ key: 'godzilla', commentCount: 10, commentPreview: { text: 'I love Godzilla', from: 'e' } }];

export function VideoVotingQuestionScreenStorySets() {
    return [
        {
            name: 'Show individual question',
            instanceKey: 'i',
            personaKey: 'a',
            sessionData: {
                videoVotingSessionState: showQuestionStateIndividual,
            },
            modulePublic: modulePublicIndividual,
            content: <DemoVideoVotingContainer showStats videoState={videoStateSecondQuestionIndividual} />,
            stories: [
                {
                    name: 'Vote for option and continue',
                    actions: [CLICK(templateIndividual.questions[1].options[0].text), CLICK('Continue')],
                },
                { name: 'Skip to next question', actions: [CLICK('Continue'), CLICK('FWRD'), CLICK('FWRD')] },
                { name: 'Skip question and navigate back', actions: [CLICK('Continue'), CLICK('FWRD'), CLICK('PREV')] },
            ],
        },
        {
            name: 'Show connected question',
            instanceKey: 'c',
            personaKey: 'a',
            sessionData: {
                videoVotingSessionState: showQuestionStateConnected,
            },
            modulePublic: modulePublicConnected,
            content: <DemoVideoVotingContainer showStats videoState={videoStateFirstQuestionConnected} />,
            stories: [
                {
                    name: 'Vote for option and continue',
                    actions: [CLICK(templateConnected.questions[0].options[0].text), CLICK('Continue')],
                },
                { name: 'Skip to next connected question', actions: [CLICK('Continue'), CLICK('FWRD')] },
            ],
        },
        {
            name: 'Final individual question',
            instanceKey: 'i',
            personaKey: 'a',
            sessionData: {
                videoVotingSessionState: finalQuestionStateIndividual,
            },
            collections: { question: collectionQuestion, derived_questionPreview: collectionDerived_questionPreview },
            modulePublic: modulePublicIndividual,
            content: <DemoVideoVotingContainer showStats videoState={videoStateFinalQuestion} />,
            stories: [{ name: 'Skip to final question and finish voting', actions: [CLICK('FWRD'), CLICK('Continue')] }],
        },
        {
            name: 'Final connected question',
            instanceKey: 'c',
            personaKey: 'a',
            sessionData: {
                videoVotingSessionState: finalQuestionStateConnected,
            },
            collections: { question: collectionQuestion, derived_questionPreview: collectionDerived_questionPreview },
            modulePublic: modulePublicConnected,
            content: <DemoVideoVotingContainer showStats videoState={videoStateFinalQuestion} />,
            stories: [{ name: 'Skip to final question and finish voting', actions: [CLICK('FWRD'), CLICK('Continue')] }],
        },
    ];
}
